// @flow
import { compose, prop } from "ramda"
import type { Selector } from "common/redux/types"

// selects the appropriate substore from root store
const base = prop("user")

export const selectLoggedIn: Selector<boolean> = compose(
  prop("loggedIn"),
  base,
)

export const selectLoggingOut: Selector<boolean> = compose(
  prop("loggingOut"),
  base,
)



// WEBPACK FOOTER //
// ./src/data/user/selectors.js